import Appsignal from '@appsignal/javascript';
import { plugin as windowEventsPlugin } from '@appsignal/plugin-window-events';
import { plugin as breadcrumbsPlugin } from '@appsignal/plugin-breadcrumbs-network';
import { plugin as pathDecoratorPlugin } from '@appsignal/plugin-path-decorator';

export const appsignal = new Appsignal({
  key: import.meta.env.VITE_APPSIGNAL_KEY,
  revision: import.meta.env.VITE_APPSIGNAL_REVISION,
});

appsignal.use(pathDecoratorPlugin());
appsignal.use(breadcrumbsPlugin());
appsignal.use(windowEventsPlugin());
